<template>
  <div class="map-controls-year-nav-wrapper">
    <year-nav-set :state="state" :direction="-1"></year-nav-set>
    <div class='year-nav-label text-center'>Navigate Years</div>
    <year-nav-set :state="state" :direction="1"></year-nav-set>
  </div>
</template>

<script>
import MapYearsNavigationSet from './MapControlsYearNavigationSet';

export default {
  name: 'map-controls-year-nav',
  props: ['state'],
  components: {
    'year-nav-set': MapYearsNavigationSet,
  },
};
</script>

<style>
  .map-controls-year-nav-wrapper {
    margin-top: 7px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: #eee;
    color: #555;
  }
  .year-nav-label {
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// MapControlsYearNavigation.vue?92bd9ee6